/**
 * 工作台横向柱状图 []
 * @param name 单位
 * @param value 数据
 * @param proportion 占比
 */
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    legend: {
      orient: "horizontal",
      bottom: 0,
      icon: "circle",
      itemWidth: 8,
      itemHeight: 8,
      itemGap: 20,
      borderRadius: 4,
      textStyle: {
        fontSize: 12,
      },
    },
    color: EchartsLightColor,
    series: [
      {
        top: 0,
        type: "funnel",
        left: "20%",
        width: "60%",
        gap: -1,
        minSize: 100,
        maxSize: 230,
        label: {
          show: true,
          position: "inside",
          color: "#fff",
          formatter: function (param) {
            return param.data.proportion + "%";
          },
        },
        data: paramObj,
      },
      {
        top: 0,
        type: "funnel",
        left: "20%",
        width: "65%",
        gap: -1,
        z: 1,
        minSize: 100,
        maxSize: 150,
        label: {
          color: "#000000",
          position: "right",
          borderWidth: 1,
          borderRadius: 4,
          padding: [11, 2],
          width: 100,
          formatter: function (param) {
            return param.value;
          },
        },
        //右侧的百分比显示的地方
        labelLine: {
          show: true,
          length: 50,
          position: "right",
          lineStyle: {
            width: 2,
            type: "solid",
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                {
                  offset: 0.4,
                  color: "#ffffff", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#28cccb", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
        },
        //主体是透明的
        itemStyle: {
          color: "transparent",
          borderWidth: 0,
          opacity: 1,
        },
        data: paramObj,
      },
    ],
  };
  return option;
}
